/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { MagnetTaskDocumentList } from '../models/magnet-task-document-list';
import { taskGetMagnetTaskDocumentList } from '../fn/task/task-get-magnet-task-document-list';
import { TaskGetMagnetTaskDocumentList$Params } from '../fn/task/task-get-magnet-task-document-list';

@Injectable({ providedIn: 'root' })
export class TaskService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `taskGetMagnetTaskDocumentList()` */
  static readonly TaskGetMagnetTaskDocumentListPath = '/task/magnet/{magnetId}/document/list';

  /**
   * Get magnet task documents.
   *
   * Get magnet task documents
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskGetMagnetTaskDocumentList()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskGetMagnetTaskDocumentList$Response(params: TaskGetMagnetTaskDocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<MagnetTaskDocumentList>> {
    const obs = taskGetMagnetTaskDocumentList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get magnet task documents.
   *
   * Get magnet task documents
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskGetMagnetTaskDocumentList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskGetMagnetTaskDocumentList(params: TaskGetMagnetTaskDocumentList$Params, context?: HttpContext): Observable<MagnetTaskDocumentList> {
    const resp = this.taskGetMagnetTaskDocumentList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MagnetTaskDocumentList>): MagnetTaskDocumentList => r.body)
    );
  }

}
